<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useOnline, useWindowSize } from '@vueuse/core';

import IconServerConnection from '@/shared/assets/img/shared/server-connection.vue';

export default defineComponent({
  name: 'EntityOnlineObserver',
  components: { IconServerConnection },
  setup() {
    const { t } = useI18n();
    const { width } = useWindowSize();
    const isOnline = useOnline();
    return {
      t,
      isOnline,
      width,
    };
  },
});
</script>

<template>
  <q-dialog :model-value="!isOnline" persistent :full-width="width <= 670">
    <q-card class="observer">
      <icon-server-connection class="observer-icon" />
      <p class="text-center">{{ t('ERRORS.OFFLINE') }}</p>
    </q-card>
  </q-dialog>
</template>

<style scoped lang="scss">
.observer {
  border-radius: 1rem;
  font-size: 1rem;
  padding: 0 2rem 2rem;
  margin: 0 1rem;

  &-icon {
    width: 100%;
    height: auto;
  }
}
</style>
